import { GenIcon } from 'react-icons';
export const MdCurrencyFlagZar = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip_zar_circle' },
                    child: [
                        {
                            tag: 'circle',
                            attr: { cx: '12', cy: '12', r: '12' },
                            child: [],
                        },
                    ],
                },
                {
                    tag: 'clipPath',
                    attr: { id: 'clip_zar_triangle' },
                    child: [
                        {
                            tag: 'path',
                            attr: { d: 'M0 0L12 12L0 24Z' },
                            child: [],
                        },
                    ],
                },
            ],
        },
        {
            tag: 'g',
            attr: { clipPath: 'url(#clip_zar_circle)' },
            child: [
                // Red top half
                {
                    tag: 'path',
                    attr: {
                        d: 'M0 0H24V12H12Z',
                        fill: '#E03C31',
                    },
                    child: [],
                },
                // Blue bottom half
                {
                    tag: 'path',
                    attr: {
                        d: 'M0 24H24V12H12Z',
                        fill: '#001489',
                    },
                    child: [],
                },
                // White Y-shape (stroke converted to fill)
                {
                    tag: 'g',
                    attr: { fill: 'none' },
                    child: [
                        {
                            tag: 'path',
                            attr: {
                                d: 'M24 12H12L0 0V24L12 12',
                                stroke: '#FFFFFF',
                                strokeWidth: '5.3',
                            },
                            child: [],
                        },
                    ],
                },
                // Black triangle with yellow border
                {
                    tag: 'g',
                    attr: { clipPath: 'url(#clip_zar_triangle)' },
                    child: [
                        {
                            tag: 'path',
                            attr: {
                                d: 'M0 0L12 12L0 24',
                                fill: '#000000',
                                stroke: '#FFB81C',
                                strokeWidth: '5.3',
                            },
                            child: [],
                        },
                    ],
                },
                // Green Y-shape
                {
                    tag: 'g',
                    attr: { fill: 'none' },
                    child: [
                        {
                            tag: 'path',
                            attr: {
                                d: 'M0 0L12 12H24M0 24L12 12',
                                stroke: '#007749',
                                strokeWidth: '3.2',
                            },
                            child: [],
                        },
                    ],
                },
                // White border stroke
                {
                    tag: 'circle',
                    attr: {
                        cx: '12',
                        cy: '12',
                        r: '11.5',
                        stroke: 'white',
                        fill: 'none',
                    },
                    child: [],
                },
            ],
        },
    ],
});
